<!--选择城市-->
<template>
  <div class="header-search">
    <div class="header-city" @click="selectCity">
      <img src="../../../../picture/index/pos.png" class="city-icon" />
      <div class="city-name">{{ city }}</div>
    </div>
    <div class="search-content" @click="searchClick">
      <img src="../../../../picture/index/search.png" class="search-icon" />
      <div class="search-input-box">搜索充电站</div>
    </div>
    <div class="btn-content">
      <div class="btn-content-flex" @click="collectionClick">
        <img src="../../../../picture/index/stars.png" class="stars-icon" />
        收藏
      </div>
      <div
        class="btn-content-flex" :class="showType == 2 ?'map':'list'"
        @click="showTypeClick"
      >
        <template v-if="showType == 2">
          <img src="../../../../picture/index/map.png" class="map-icon" />
          地图
        </template>
        <template v-else>
          <img src="../../../../picture/index/list.png" class="map-icon" />
          列表
        </template>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "pi-header-search",
  model: {
    prop: "value",
    event: "change",
  },
  components: {
    
  },
  props: {
    showType: {
      type: Number,
      default: 1
    },
    city: {
      type: String,
      default: ''
    }
  },
  watch: {},
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
    selectCity() {
      this.$router.push('/home/city?city=' + this.city)
    },
    showTypeClick(){
      this.$emit('change')
    },
    searchClick(){
      this.$router.push('/home/home-search-sta')
    },
    collectionClick(){
      this.$router.push('/my/collection')
    }
  },
};
</script>

<style lang="less" scoped>
.header-search{
  padding: 0.16rem 0.20rem;
  height: 0.88rem;
  box-sizing: border-box;
  color: #999999;
  display: flex;

  background-color: #fff;
  z-index: 10;
}
.header-search-height{
  height: 0.88rem;
}
.header-city{
  width: 1.38rem;
  position: relative;
  padding: 0.08rem 0;
}
.header-city .city-icon{
  width: 0.34rem;
  height: 0.34rem;
  position: absolute;
  left: 0;
  top: 0.11rem;
}
.header-city .city-name{
  padding-left: 0.39rem;
  font-size: 0.28rem;
  line-height: 0.40rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.search-content{
  flex: 1;
  height: 0.56rem;
  background-color: #F5F5F5;
  border-radius: 0.28rem;
  position: relative;
}
.search-content .search-icon{
  width: 0.40rem;
  height: 0.40rem;
  position: absolute;
  left: 0.05rem;
  top: 0.06rem;
}
.search-content .search-input-box{
  padding: 0.12rem 0.10rem 0.12rem 0.52rem;
  font-size: 0.24rem;
  line-height: 0.33rem;
}
.btn-content{
  display: flex;
  color: #666666;
  font-size: 0.28rem;
  line-height: 0.40rem;
  margin-left: 0.05rem;
}
.btn-content .btn-content-flex{
  width: 1.15rem;
  display: flex;
  align-items: center;
  justify-items: center;
  overflow: hidden;
}
.btn-content .btn-content-flex.map{
  background: linear-gradient(267deg, #FFFFFF 0%, #E5ECFF 100%);
  box-shadow: 0px 0px 0.10rem 0px #F5F5F5;
  border-radius: 28px;
}
.btn-content .btn-content-flex.list{
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  background: linear-gradient(270deg, #FFFFFF 0%, #D4FFF4 100%);
  box-shadow: 0px 0px 0.10rem 0px #F5F5F5;
  border-radius: 28px;
}
.btn-content .btn-content-flex .stars-icon{
  width: 0.34rem;
  height: 0.34rem;
  margin:0 0.05rem;
}
.btn-content .btn-content-flex .map-icon{
  width: 0.46rem;
  height: 0.46rem;
  margin:0 0.05rem;
} 

</style>
